import React from "react";
import { useState } from "react";
import { Redirect } from "react-router-dom";
import {
    BrowserRouter as Router,
    Link,
    useLocation
} from "react-router-dom";

export default function AbonnementStatus(props, { status }) {
    const [redirectLogin, setRedirect] = useState(false);
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    let query = useQuery();

    return (
        <div>
            <main class="main-wrapper login-page">
                {status = query.get("status") === "succes" ? (
                    <div class="container-login">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                console.log("test11", props.location.state)
                                if (
                                    props.location.state &&
                                    props.location.state.abonnement &&
                                    ["ANNULE", "NON_ABONNEE"].includes(
                                        props.location.state.abonnement.statut
                                    )
                                ) {
                                    window.location.replace(
                                        props.location.state.abonnement.urlAbonnement
                                    );
                                } else {
                                    setRedirect(true);
                                }
                            }}
                            class="box-login"
                        >
                            <h5 class="mb-4">
                                Mise à jour des moyens de paiement réussie.
                              <br />
                                <br />
                                    Votre abonnement a été réactivé.
                            </h5>
                            <button type="submit" class="btn-gradient mt-4">
                                Se connecter
                            </button>
                        </form>
                        {redirectLogin ? (
                            <Redirect
                                to={{
                                    pathname: "/login",
                                }}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                ) : ("null"
                )},
                    {status = query.get("status") === "failed" ? (
                    <div class="container-login">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                console.log("test11", props.location.state)
                                if (
                                    props.location.state &&
                                    props.location.state.abonnement &&
                                    ["ANNULE", "NON_ABONNEE"].includes(
                                        props.location.state.abonnement.statut
                                    )
                                ) {
                                    window.location.replace(
                                        props.location.state.abonnement.urlAbonnement
                                    );
                                } else {
                                    setRedirect(true);
                                }
                            }}
                            class="box-login"
                        >
                            <h5 class="mb-4">
                                La mise à jour de votre abonnement a échoué.
                              <br />
                                <br />
                                Essayez à nouveau en vous connectant à votre compte.
                            </h5>
                            <button type="submit" class="btn-gradient mt-4">
                                Réessayer
                            </button>
                        </form>
                        {redirectLogin ? (
                            <Redirect
                                to={{
                                    pathname: "/login",
                                }}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                ) : ("null"
                )}

            </main>
        </div>
    );
}
